module.exports = __webpack_public_path__ + "static/media/spinner.c6cdd7d7.png";